import { render, staticRenderFns } from "./RoleCheck.vue?vue&type=template&id=f432fbc2&scoped=true"
import script from "./RoleCheck.vue?vue&type=script&lang=js"
export * from "./RoleCheck.vue?vue&type=script&lang=js"
import style0 from "./RoleCheck.vue?vue&type=style&index=0&id=f432fbc2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f432fbc2",
  null
  
)

export default component.exports